module.exports = __webpack_public_path__ + "public/img/平台名称.1c320f76.png";